import { variables } from "./variables/variables";
export var Theme = {
  breakpoints: [variables.breakpoints.md, variables.breakpoints.lg, variables.breakpoints.xlg],
  gridGap: 1.5,
  gridSize: 12,
  ruleSets: {
    button: {}
  },
  space: ['0', '1rem', '1.5rem', '3rem', '4.5rem', '6rem', '7.5rem'],
  variables: variables
};